import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../sims/style";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import AssetAreaCondition from "../AssetAreaConditionReport";

import { TrackCircuitReportSchema, TrackCircuitReportSchemaHeader } from "./TrackCircuitReportSchema";
import React from "react";
const masterKey = [
  { key: "C", value: "Tests completed on all applicable components, no exceptions found, and condition left in compliance." },
  { key: "A", value: "Adjustments made (identified in associated comments), test completed, and condition left in compliance." },
  {
    key: "R",
    value: "Repairs and/or Replacements made (identified in associated comments), test completed, and condition left in compliance.",
  },
  { key: "G", value: "Governed by Special Instruction." },
  { key: "NT", value: "The equipment was not tested in this inspection." },
  { key: "NC", value: "Not Compliant." },
  { key: "N", value: "Test Not Applicable." },
];
const TrackCircuitReport = (props) => {
  const { reportData } = props;
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let grouped = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [
    "PATH_ACTrackCircuitTest",
    "PATH_AssetAreaCondition",
  ]);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(grouped);

  return decodedReports.map((report, i) => <ViewReport key={i} data={report} {...props} />);
};
const ViewReport = (props) => {
  const { data } = props;
  const { decodedData } = data;
  let tourfound = decodedData.find((e) => (e.otherInfo || {}).tours);
  let tours = tourfound && tourfound.otherInfo.tours;
  let tour = tours && tours[0];
  const assetAreaConditionData = decodedData.filter((t) => t.testCode === "PATH_AssetAreaCondition");
  let showReport = assetAreaConditionData.length !== decodedData.length;
  return (
    showReport && (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection {...props} fontSizeOverride={"35px"} />
        <span className="spacer"></span>
        <ReportFraInfoSectionContainer
          {...props}
          data={{ ...data, tourNumber: (tour && tour.name) || (tour && tour.description) || " " }}
        />
        <ReportFraConditionsMasterKey masterKey={masterKey} />
        <span className="spacer"></span>
        <AssetAreaCondition data={assetAreaConditionData} />
        <table className="table-bordered">
          <ReportTableSectionRenderer section={TrackCircuitReportSchemaHeader} rowsData={{}} />

          <ReportTableSectionRenderer
            section={TrackCircuitReportSchema}
            rowsData={{ ...(decodedData[0].summary ? decodedData[0].summary : {}), date: decodedData[0].date }}
          />
        </table>
        <br />
        <p style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <span>
            <b>Signal Repairman:</b> ___________________________
          </span>
        </p>
        <br />

        <p>Test Form: ST 1 11/2015</p>

        <p></p>
      </div>
    )
  );
};

export default TrackCircuitReport;



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/TrackCircuitReport/index.jsx